import { SubSection } from "context/BlogContext";
import React from "react";

interface PreviewEmbedProps {
  subSection: SubSection;
}

const PreviewEmbed: React.FC<PreviewEmbedProps> = ({ subSection }) => {
  return (
    <div>
      {subSection.type === "embed" && (
        <div className="w-full pt-5">
          {subSection.title && (
            <p className="pt-3 text-lg">{subSection.title}</p>
          )}
          <div className="h-[250px] flex justify-center w-auto">
            <iframe
              className="rounded-md h-full w-auto aspect-video"
              title="Embedded YouTube Video"
              src={subSection.attrs.url.replace("shorts/", "embed/")}
            ></iframe>
          </div>
          {/* <p className="pt-3">{subSection.attrs?.url}</p>
          <p className="pt-3">{subSection.attrs?.caption}</p> */}
        </div>
      )}
    </div>
  );
};

export default PreviewEmbed;
